import {Component, Input, OnInit} from '@angular/core';
import {TransportInterventionsStatus} from 'shared';

@Component({
  selector: 'app-transport-interventions-realtime-report-details',
  templateUrl: './transport-interventions-realtime-report-details.component.html',
  styleUrls: ['./transport-interventions-realtime-report-details.component.scss']
})
export class TransportInterventionsRealtimeReportDetailsComponent implements OnInit {
  @Input()
  item: TransportInterventionsStatus;

  constructor() {
  }

  ngOnInit(): void {
  }

}
